var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.458832 7.39418C0.459221 7.39379 0.45961 7.3934 0.459999 7.39301L7.39465 0.458618C7.69024 0.162903 8.08323 0 8.50125 0C8.91927 0 9.31226 0.162773 9.60798 0.458488L16.539 7.38938C16.5413 7.39172 16.5437 7.39418 16.546 7.39651C17.153 8.00701 17.152 8.99753 16.543 9.60647C16.2648 9.8848 15.8974 10.046 15.5045 10.0629C15.4886 10.0644 15.4725 10.0652 15.4563 10.0652H15.1799V15.1685C15.1799 16.1784 14.3582 17 13.3481 17H10.6351C10.3601 17 10.137 16.777 10.137 16.502V12.501C10.137 12.0402 9.76219 11.6653 9.30137 11.6653H7.70113C7.24031 11.6653 6.86548 12.0402 6.86548 12.501V16.502C6.86548 16.777 6.64252 17 6.36743 17H3.65437C2.64427 17 1.82262 16.1784 1.82262 15.1685V10.0652H1.56634C1.14845 10.0652 0.755455 9.90244 0.45961 9.60673C-0.149979 8.99675 -0.150238 8.00455 0.458832 7.39418Z",
    fill: "#010101"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.7c6fe1d6.svg";
export { ForwardRef as ReactComponent };